import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../../Pages/Public/Login";
import CreateAccount from "../../Pages/Public/CreateAccount";
import ForgotPassword from "../../Pages/Public/ForgotPassword";
import VerifyEmail from "../../Pages/Public/VerifyEmail";
import ResetPassword from "../../Pages/Public/ResetPassword";
import VerifiedSuccessfully from "../../Pages/Public/VerifiedSuccessfully";
import Subscription from "../../Pages/Public/Subscription";

const PublicRoutes = ({ setUser }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/create-account"
        element={<CreateAccount setUser={setUser} />}
      />
      <Route path="/email-unverified" element={<VerifyEmail />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/email-verify/:id" element={<VerifiedSuccessfully />} />
      <Route
        path="/subscription"
        element={<Subscription setUser={setUser} />}
      />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
